module.exports = {
  productionPlatform: 'web',

  // Map.ir Configuration (using proxy for mobile app compatibility)
  mapir: {
    apiKey: '', // Not needed when using proxy
    tileUrl: 'https://map.4-rah.com/tile/{z}/{x}/{y}.png',
  },
  gpsServers: {
    server1: {
      url: 'https://s1.4-rah.com',
      port: 5000,
    },
  },
  gpsServersGL: {
    server1: {
      url: 'https://s1-gl.4-rah.com',
      port: 5000,
    },
  },
  apiServers: {
    url: 'https://api.4-rah.com',
    port: 3000,
  },
  apiServersGL: {
    url: 'https://api.4-rah.com',
    port: 3000,
  },
  isCreator: false,
  carTypes: [
    {
      value: '0', text: 'سواری', icon: 'mdi-car-hatchback', src: 'car', color: 'rgb(230, 27, 27)',
    },
    {
      value: '1', text: 'تاکسی', icon: 'mdi-taxi', src: 'taxi', color: 'rgb(215, 177, 29)',
    },
    {
      value: '2', text: 'موتورسیکلت', icon: 'mdi-motorbike', src: 'motorbike', color: 'rgb(230, 27, 27)',
    },
    {
      value: '3', text: 'تریلر', icon: 'mdi-truck', src: 'truck', color: 'rgb(230, 27, 27)',
    },
    {
      value: '4', text: 'مینی بوس', icon: 'mdi-bus-school', src: 'bus', color: 'rgb(107, 201, 217)',
    },
    {
      value: '5', text: 'اتوبوس', icon: 'mdi-bus-side', src: 'bus', color: 'rgb(88, 219, 51)',
    }, /*
    {
      value: '6', text: 'دوچرخه', icon: 'mdi-bicycle', src: 'bicycle', color: 'rgb(108, 82, 123)',
    }, */
    {
      value: '7', text: 'وانت', icon: 'mdi-car-pickup', src: 'pickup', color: 'rgb(59, 83, 213)',
    },
    {
      value: '8', text: 'ون', icon: 'mdi-car-estate', src: 'estate', color: 'rgb(230, 27, 27)',
    },
  ],
}
